import { Menu } from 'antd';
import { observer } from 'mobx-react';
import React, { FC, useEffect, useState } from 'react';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import { StatusText } from '@/presentation/components/status-text';
import { TapdTips } from '@/presentation/components/tapd-info/tapd-tips';
import { useStores } from '@/presentation/store';
import { FieldKey, getLocalFieldLabelByValue } from '@/proto/field';

export interface TapdData {
  tapdStatus: string;
  tapdUrl: string;
}

export const TapdStatusColor = {
  SendSingleColor: '#3DD598',
  NotSendSingleColor: '#FF974A',
  SendSingleBgColor: '#ebfbf5',
  NotSendSingleBgColor: '#fff5ed',
};

const INIT_PARAMS  = {
  status: true,
};

enum TapdStatus {
  View = 'view',     // 查看tapd
  Delete = 'delete', // 取消关联tapd
  Update = 'update', // 重关联tapd
  Create = 'create', // 创建tapd
}

export const TapdStatusTextRender: FC<{
  tapdData: TapdData;
  tapdSubmit: (data?: any) => void;
  rowData?: any;
  pageId: string;
  deleteTapd: () => void;
  updateTapd: () => void;
}> = observer(({ tapdData, tapdSubmit, rowData, deleteTapd, updateTapd, pageId }) => {
  const [isTapdIssueBtn, setIsTapdIssueBtn] = useState(false);
  const { tapdList, getTapdProductList } = useStores().TapdStore;
  const { productId } = useStores().ProductStore;
  const handleMenu = (e: any) => {
    if (e.key === TapdStatus.View) openTapdLink();
    if (e.key === TapdStatus.Delete) deleteTapd();
    if (e.key === TapdStatus.Update) updateTapd();
    if (e.key === TapdStatus.Create) tapdSubmit(rowData);
  };

  const menuList = tapdData.tapdUrl ? [
    {
      name: '查看',
      key: TapdStatus.View,
    },
    {
      name: '重关联',
      key: TapdStatus.Update,
    },
    {
      name: '取消关联',
      key: TapdStatus.Delete,
    },
  ] : [
    {
      name: '关联缺陷',
      key: TapdStatus.Update,
    },
    {
      name: '创建缺陷',
      key: TapdStatus.Create,
    },
  ];

  const openTapdLink = () => {
    window.open(tapdData.tapdUrl);
    reportClick(pageId, CUSTOM_ACTIONS.commonJumpTapd, { from: pageId });
  };

  const renderMenu = () => (<Menu onClick={handleMenu}>
    {menuList.map(item => <Menu.Item key={item.key}>
      {item.name}
    </Menu.Item>)}
  </Menu>);

  useEffect(() => {
    INIT_PARAMS.status && getTapdProductList();
    INIT_PARAMS.status = false;
    return () => {
      INIT_PARAMS.status = true;
    };
  }, [productId]);

  useEffect(() => {
    setIsTapdIssueBtn(!tapdList.length);
  }, [tapdList]);

  const spanText = tapdData.tapdStatus === '' ? '未派单' : getLocalFieldLabelByValue(FieldKey.TapdStatus, tapdData.tapdStatus);
  const textColor = !tapdData.tapdUrl ? TapdStatusColor.NotSendSingleColor : TapdStatusColor.SendSingleColor;
  const bgColor = !tapdData.tapdUrl ? TapdStatusColor.NotSendSingleBgColor : TapdStatusColor.SendSingleBgColor;

  const renderStatusText = () => <StatusText
    status={spanText! as string}
    overlay={renderMenu()}
    textColor={textColor}
    bgColor={bgColor}
    disabled={!tapdList.length}
  />;

  return (
    <div>
      {!isTapdIssueBtn
        ? renderStatusText()
        : <TapdTips>
            <span
              style={{
                color: textColor,
                background: bgColor,
                cursor: 'pointer',
                padding: '5px 8px',
                fontSize: '14px',
              }}
            >
              {spanText}
            </span>
        </TapdTips>}
    </div>
  );
});
